import { Modal, Alert, AlertTitle, Button } from '@mui/material';

interface Props {
  openModal: boolean;
  isRascunho: boolean;
  onClose: () => void;
}

const OrderSaveSuccessModal = (props: Props) => {
  const handleEnterPress = (ev: React.KeyboardEvent<HTMLDivElement>) => {
    if (ev.key === 'Enter') {
      props.onClose();
    }
  };

  return (
    <Modal
      open={props.openModal}
      onClose={props.onClose}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      onKeyPress={(ev) => handleEnterPress(ev)}
    >
      <Alert
        sx={{
          width: { md: '35%', sm: '65%', xs: '80%' },
          alignItems: 'center',
        }}
        action={<Button onClick={props.onClose}>Ok</Button>}
      >
        <AlertTitle>Sucesso</AlertTitle>
        {props.isRascunho
          ? 'Rascunho salvo com sucesso'
          : 'Pedido realizado com sucesso'}
      </Alert>
    </Modal>
  );
};

export default OrderSaveSuccessModal;
